import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CookieService} from 'ngx-cookie-service';
import {empty} from 'sdv-common';
import {AlarmLevelService} from '../../service/alarm-level.service';
import {AlarmTypeService} from '../../service/alarm-type.service';
import {AlarmService} from '../../service/alarm.service';
import {ApiService} from '../../service/api.service';
import {LanguageService} from '../../service/language.service';
import {keys, reload} from '../../shared/constants';

@Component({
  selector: 'add-alarm',
  templateUrl: './add-alarm.component.html',
  styleUrls: ['./add-alarm.component.scss']
})
export class AddAlarmComponent implements OnInit {

  error = '';
  loading = false;
  submitted = false;
  formGroup: FormGroup;

  langId = 1;
  levelId = 2;
  locales = {};

  constructor(private apiService: ApiService,
              private alarmService: AlarmService,
              private languageService: LanguageService,
              private alarmTypeService: AlarmTypeService,
              private alarmLevelService: AlarmLevelService,
              private formBuilder: FormBuilder,
              private cookieService: CookieService) {
  }

  ngOnInit() {
    this.formGroup = this.formBuilder.group({
      code: ['', Validators.required],
      type: ['', Validators.required],
      title: ['', Validators.required],
      text: ['', Validators.required]
    });
  }

  get fg() {
    return this.formGroup.controls;
  }

  switchLevel(id: number) {
    this.levelId = id;
    this.renderer(this.levelId, this.langId, false);
  }

  switchLanguage(id: number) {
    this.langId = id;
    this.renderer(this.levelId, this.langId, false);
  }

  renderer(levelId: number, langId: number, overwrite: boolean) {
    let data = this.locales[levelId + ':' + langId];
    if (!data) {
      this.locales[levelId + ':' + langId] = data = {
        languageId: langId,
        levelId: levelId,
        title: '',
        text: ''
      };
    }
    if (overwrite) {
      data.title = this.fg.title.value;
      data.text = this.fg.text.value;
    }
    this.fg.title.setValue(data.title);
    this.fg.text.setValue(data.text);
  }

  onSubmit() {
    this.submitted = true;
    if (this.formGroup.invalid) {
      return;
    }
    this.loading = true;

    let _this = this;
    this.apiService.send({
      command: 'create_alarm',
      request: {
        code: this.fg.code.value,
        typeId: this.fg.type.value,
        locales: Object.values(this.locales).filter(n => n['title'] != empty || n['text'] != empty),
        projectId: this.cookieService.get(keys.project)
      }
    }, (response, headers) => {
      response = response.response;
      if (!response.error) {
        reload('/alarms');
        return;
      }

      _this.error = response.error.message;
      _this.loading = false;
    });
  }
}
